import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {setModalVisibility} from "../../core/app/setModalVisibility/actions";
import {ModalType} from "../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../core/models/custom/modalVisibility.payload";
import ContentKeys from "../../core/utilities/contentKeys";
import {Images} from "../../core/utilities/images";
import {IStore} from "../../core/utilities/reducers";
import ContentKey from "../ContentKey/ContentKey";
import "./AppHeader.scss";

interface IProps {
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
}

const AppHeader = (props: IProps) => {
  
  return (
    <div id="app-header">
      <img className="logo" src={Images.logo} alt="logo"/>
      <ContentKey
        className="title"
        contentKey={ContentKeys.HOME_HEADER}
      />
      <img
        className="drawer" src={Images.how_to_play} alt="drawer"
        onClick={() => props.setModalVisibility({modal: ModalType.DRAWER_HOW_TO_PLAY, isVisible: true})}
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
